import { Card, Space, Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { orderBoxStatus } from "constants/index";
import classNames from "classnames/bind";
import style from '../../index.module.scss'

const cx = classNames.bind(style)
export default function TableOrderBox({ loading, listBoxOrder }) {
    const { t } = useTranslation()

    const column = [
        {
            key: 'orderNumber',
            dataIndex: 'orderNumber',
            title: t('orderNumber'),
            onHeaderCell: (column) => ({ className: cx('order-header') }),
        },
        {
            key: 'name',
            dataIndex: 'name',
            title: t('box'),
            width: '40%',
            onHeaderCell: (column) => ({ className: cx('order-header') }),
            render: (_, row) => (
                <Space direction="vertical">
                    {
                        row.boxes.map(box =>box.box.name)
                    }
                </Space>
            )
        },
        {
            key: 'quantity',
            dataIndex: 'quantity',
            title: t('quantity'),
            onHeaderCell: (column) => ({ className: cx('order-header') }),
            render: (_, row) => (
                <Space direction="vertical">
                    {
                        row.boxes.map(box =>box.quantity)
                    }
                </Space>
            )
        },
        {
            key: 'orderAt',
            dataIndex: 'orderAt',
            title: t('orderAt'),
            onHeaderCell: (column) => ({ className: cx('order-header') }),
            render: (time) => moment(time).format('YYYY-MM-DD HH:mm')
        },
        {
            key: 'deliveryAt',
            dataIndex: 'deliveryAt',
            title: t('deliveryAt'),
            onHeaderCell: (column) => ({ className: cx('order-header') }),
            render: (time) => moment(time).format('YYYY-MM-DD HH:mm')
        },
        {
            key: 'status',
            dataIndex: 'status',
            title: t('status'),
            onHeaderCell: (column) => ({ className: cx('order-header') }),
            render: (status) => {
                const current = orderBoxStatus.find(item => item.value == status)
                return <Tag color={current?.color}>{t(current?.label)}</Tag>
            }
        },
    ]
 
    return (
        <Card title={t('boxIndividualOrder')}>
            <Table
                loading={loading}
                columns={column}
                dataSource={listBoxOrder}
                bordered
                pagination={false}
                scroll={{ y: 350 }}
            />
        </Card>
    )
}